import React from 'react';
import Reflux from 'reflux';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';
import { Button } from 'bootstrap';
import role from 'shared/lib/role';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import ShowActions from 'flux/actions/ShowActions';
import PermissionStore from 'flux/stores/PermissionStore';

export default React.createClass({
  displayName: 'OverUnderToggler',

  mixins: [Reflux.connect(PermissionStore, 'permissions')],

  getDefaultProps() {
    return {
      displayActualDuration: false,
    };
  },

  render() {
    const { eventId, user } = this.props;
    const hasEventShowCaller = role.hasEventShowCallerRole(user, eventId);
    const hasOverUnderPermission = this.state.permissions.get('overUnder');

    if (!hasEventShowCaller || !hasOverUnderPermission) {
      return null;
    }

    return (
      <div className="over-under-toggler">
        <div className="over-under-toggler-title">Over/under time</div>
        <div className="over-under-toggler-row2">
          {this._getToggleNode()}
          {this._getToggleStatusNode()}
          {this._getButtonNode()}
        </div>
      </div>
    );
  },

  _getToggleNode() {
    const { displayActualDuration } = this.props;

    return (
      <div className="over-under-toggler-switch">
        <ToggleSwitch
          on={displayActualDuration}
          onClick={ShowActions.toggleActualDurations}
        />
      </div>
    );
  },

  _getToggleStatusNode() {
    const { displayActualDuration } = this.props;

    const statusClass =
      'over-under-toggler-status' +
      (displayActualDuration ? ' over-under-toggler-status-on' : '');

    return (
      <div className={statusClass}>{displayActualDuration ? 'ON' : 'OFF'}</div>
    );
  },

  _deleteActualDurationsHandler() {
    CuesheetActions.deleteActualDurations();
  },

  _getButtonNode() {
    const { displayActualDuration } = this.props;

    if (!displayActualDuration) return null;

    return (
      <Button
        onClick={this._deleteActualDurationsHandler}
        className="over-under-toggler-reset"
      >
        Reset
      </Button>
    );
  },
});
